import {
  createBaseThemeOptions,
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme';

export const lightTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      primary: {
        main: '#213547',
      },
      secondary: {
        main: '#3a5a6e',
      },
      navigation: {
        background: '#213547',
        indicator: '#6bc1a0',
        color: '#d5dce4',
        selectedColor: '#ffffff',
        navTextColor: '#d5dce4',
      },
    },
  }),
  defaultPageTheme: 'home',
  pageTheme: {
    home: genPageTheme({ colors: ['#213547', '#3a5a6e'], shape: shapes.wave }),
    documentation: genPageTheme({
      colors: ['#213547', '#3a5a6e'],
      shape: shapes.wave2,
    }),
    tool: genPageTheme({
      colors: ['#213547', '#3a5a6e'],
      shape: shapes.round,
    }),
    service: genPageTheme({
      colors: ['#213547', '#3a5a6e'],
      shape: shapes.wave,
    }),
    website: genPageTheme({
      colors: ['#213547', '#3a5a6e'],
      shape: shapes.wave,
    }),
    library: genPageTheme({
      colors: ['#213547', '#3a5a6e'],
      shape: shapes.wave,
    }),
    other: genPageTheme({
      colors: ['#213547', '#3a5a6e'],
      shape: shapes.wave,
    }),
    app: genPageTheme({ colors: ['#213547', '#3a5a6e'], shape: shapes.wave }),
    apis: genPageTheme({ colors: ['#213547', '#3a5a6e'], shape: shapes.wave }),
  },
});

export const darkTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.dark,
      primary: {
        main: '#6bc1a0',
      },
      secondary: {
        main: '#8fd4bb',
      },
      navigation: {
        background: '#1a2a35',
        indicator: '#6bc1a0',
        color: '#d5dce4',
        selectedColor: '#ffffff',
        navTextColor: '#d5dce4',
      },
    },
  }),
  defaultPageTheme: 'home',
  pageTheme: {
    home: genPageTheme({ colors: ['#1a2a35', '#213547'], shape: shapes.wave }),
    documentation: genPageTheme({
      colors: ['#1a2a35', '#213547'],
      shape: shapes.wave2,
    }),
    tool: genPageTheme({
      colors: ['#1a2a35', '#213547'],
      shape: shapes.round,
    }),
    service: genPageTheme({
      colors: ['#1a2a35', '#213547'],
      shape: shapes.wave,
    }),
    website: genPageTheme({
      colors: ['#1a2a35', '#213547'],
      shape: shapes.wave,
    }),
    library: genPageTheme({
      colors: ['#1a2a35', '#213547'],
      shape: shapes.wave,
    }),
    other: genPageTheme({
      colors: ['#1a2a35', '#213547'],
      shape: shapes.wave,
    }),
    app: genPageTheme({ colors: ['#1a2a35', '#213547'], shape: shapes.wave }),
    apis: genPageTheme({ colors: ['#1a2a35', '#213547'], shape: shapes.wave }),
  },
});
